import { API_BASE_URL, request } from './request';

export const uploadContent = async (formData) => {
  const url = `${API_BASE_URL}/content/upload`;
  const options = formData instanceof FormData
    ? { method: 'POST', body: formData }
    : { method: 'POST', body: JSON.stringify(formData) };
  return request(url, options);
};

export const previewContentMetadata = async (formData) => request(`${API_BASE_URL}/content/preview_metadata`, {
  method: 'POST',
  body: formData,
});

export const previewXhsNoteSummary = async (params = {}) => request(`${API_BASE_URL}/content/preview_xhs_note_summary`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const previewXhsNoteTags = async (params = {}) => request(`${API_BASE_URL}/content/preview_xhs_note_tags`, {
  method: 'POST',
  body: JSON.stringify(params),
});

export const createXhsNote = async (formData) => request(`${API_BASE_URL}/content/create_xhs_note`, {
  method: 'POST',
  body: formData,
});

export const getContentList = async (params = {}) => {
  const defaultParams = {
    page: 1,
    page_size: 20,
    sort_field: 'ingested_at',
    sort_order: '降序',
    ...params,
  };
  return request(`${API_BASE_URL}/content/list`, {
    method: 'POST',
    body: JSON.stringify(defaultParams),
  });
};

export const searchContent = async (searchParams = {}) => request(`${API_BASE_URL}/content/search`, {
  method: 'POST',
  body: JSON.stringify(searchParams),
});

export const deleteContent = async (searchParams = {}) => request(`${API_BASE_URL}/content/delete`, {
  method: 'POST',
  body: JSON.stringify(searchParams),
});

export const downloadContent = async (contentId) => {
  const url = `${API_BASE_URL}/content/download`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ content_id: contentId }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && (contentType.includes('application/octet-stream')
      || contentType.includes('application/zip')
      || contentType.includes('application/pdf')
      || contentType.includes('video/')
      || contentType.includes('image/'))) {
      const blob = await response.blob();
      const contentDisposition = response.headers.get('content-disposition');
      let filename = `content_${contentId}`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
          if (filename.startsWith('UTF-8\'\'')) {
            filename = decodeURIComponent(filename.replace(/^UTF-8''/, ''));
          }
        }
      }

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      return { status: 'success', message: '下载成功' };
    }
    return await response.json();
  } catch (error) {
    console.error('下载失败:', error);
    throw error;
  }
};

export const getContentDetail = async (searchParams = {}) => request(`${API_BASE_URL}/content/detail`, {
  method: 'POST',
  body: JSON.stringify(searchParams),
});

export const modifyContentDetail = async (searchParams = {}) => request(`${API_BASE_URL}/content/update`, {
  method: 'POST',
  body: JSON.stringify(searchParams),
});
